import { GroupModeEnums } from "@/features/groups/constants/group.constant";
import { cn } from "@/lib/utils";
import { DnsServices, Wikis, Locked } from "@carbon/icons-react";

export const getGroupIconElement = ({
  mode,
  size,
  className,
}: {
  mode: GroupModeEnums;
  size?: number;
  className?: string;
}) => {
  switch (mode) {
    case GroupModeEnums.PRIVATE:
      return (
        <Locked
          size={size}
          className={cn(className)}
        />
      );
    case GroupModeEnums.PUBLIC:
      return (
        <Wikis
          size={size}
          className={cn(className)}
        />
      );
    case GroupModeEnums.PUBLIC_PARTIAL:
      return (
        <DnsServices
          size={size}
          className={cn(className)}
        />
      );
    default:
      return null;
  }
};

export const getGroupTextElement = ({ mode }: { mode: GroupModeEnums }) => {
  switch (mode) {
    case GroupModeEnums.PRIVATE:
      return "Riêng tư";
    case GroupModeEnums.PUBLIC:
      return "Công khai toàn diện";
    case GroupModeEnums.PUBLIC_PARTIAL:
      return "Công khai một phần";
    default:
      return "";
  }
};

export const getGroupDescriptionElement = ({
  mode,
  isOrganization = false,
}: {
  mode: GroupModeEnums;
  isOrganization?: boolean;
}) => {
  const text = isOrganization ? "tổ chức" : "nhóm";
  switch (mode) {
    case GroupModeEnums.PRIVATE:
      return `Chỉ thành viên trong ${text} hoặc người dùng được gửi lời mời tham gia mới có thể tìm kiếm ${text}`;
    case GroupModeEnums.PUBLIC:
      return `Bất kỳ ai cũng có thể tìm thấy ${text} và gửi yêu cầu tham gia ${text}, người trong ${text} có thể gửi lời mời tới người dùng Taga ngoài tổ chức`;
    case GroupModeEnums.PUBLIC_PARTIAL:
      return `Bất kỳ ai cũng có thể tìm thấy ${text} và gửi yêu cầu tham gia ${text} của bạn và chờ phê duyệt`;
    default:
      return "";
  }
};
